export const SUBSCRIPTION_ACTIONS = {
  SET_STATE: 'subscription/setState',
  GET_SUBSCRIPTION: 'subscription/getSubscription',
  DESTROY: "subscription/destroy"
};
